import { Injectable, inject } from '@angular/core';

import { NavigationService } from '../_services/navigation.service';

@Injectable({
  providedIn: 'root'
})

// this guard forces a redirection to the '/generator' route.
// It forwards all query params from the current route.
export class RedirectToGeneratorGuard  {
  private navigationService = inject(NavigationService);

  canActivate() {
    this.navigationService.navigate('/generator');
    return true;
  }
}

